export default function Title({children, ...props}) {
  return <div className="my-4 font-semibold underline uppercase" {...props}>
    {children}
  </div>
}
